import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoIcon from "../../assets/svg/Logo";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);

  useEffect(() => {
    const handleScroll = () => setY(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "60px" } : { height: "80px" }}>
      <NavInner className="container flexSpaceCenter">
        <Link className="pointer flexNullCenter" to="home" smooth={true}>
          <LogoIcon />
          <h1 style={{ marginLeft: "15px" }} className="font20 extraBold">
            {/* Add your logo text here if needed */}
          </h1>
        </Link>
        {/* Burger menu removed */}
        <UlWrapper className="flexNullCenter">
          <li className="semiBold font15 pointer">
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
              Home
            </Link>
          </li>
          <li className="semiBold font15 pointer">
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="projects" spy={true} smooth={true} offset={-80}>
              Products
            </Link>
          </li>
          <li className="semiBold font15 pointer">
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="about-us" spy={true} smooth={true} offset={-80}>
              About Us
            </Link>
          </li>
          <li className="semiBold font15 pointer">
            <Link activeClass="active" style={{ padding: "10px 15px" }} to="contact" spy={true} smooth={true} offset={-80}>
              Contact
            </Link>
          </li>
        </UlWrapper>
        <UlWrapperRight className="flexNullCenter">
          {/* Add right-side nav items if needed */}
        </UlWrapperRight>
      </NavInner>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


